import script from "./BaseNavList.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseNavList.vue?vue&type=script&setup=true&lang=js"

import "./BaseNavList.vue?vue&type=style&index=0&id=ae444924&lang=scss"

const __exports__ = script;

export default __exports__